import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import PurchaseOrders from 'types/entities/PurchaseOrders';

const RefChronoCell = React.memo((row: PurchaseOrders) => (
  <Tooltip arrow title={row.referencechrono_offreref ?? ''}>
    <Typography noWrap variant="body2">
      {row?.referencechrono_offreref}
    </Typography>
  </Tooltip>
));

export default RefChronoCell;
